module.exports = __webpack_public_path__ + "static/media/jaredsuasin.68e89914.jpeg";